export default __webpack_public_path__ + "static/media/mobility_arrow_3.88f27fce.svg";